import React from 'react';
import PropTypes from 'prop-types';

import MotifToast from '@ey/motif-react-wrapper/Toast';

const Toast = ({message = '', ...rest}) => <MotifToast {...rest}>{message}</MotifToast>;

Toast.propTypes = {
	message: PropTypes.string.isRequired
};

export default Toast;
